import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { motion } from 'framer-motion';
import { itemVariants } from '@/components/animations';

export const MessagingSkeleton = () => {
    return (
        <motion.div variants={itemVariants}>
            <Card className="p-6">
                {/* Header */}
                <div className="flex items-start justify-between mb-6">
                    <div className="flex items-start space-x-4">
                        <Skeleton className="h-12 w-12 rounded-xl" />
                        <div className="space-y-2">
                            <Skeleton className="h-6 w-48" />
                            <div className="flex space-x-2">
                                <Skeleton className="h-5 w-16" />
                                <Skeleton className="h-5 w-24" />
                            </div>
                        </div>
                    </div>
                    <Skeleton className="h-8 w-20" />
                </div>

                {/* Content Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div className="space-y-3">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="flex items-center space-x-3">
                                <Skeleton className="h-8 w-8 rounded-lg" />
                                <div className="space-y-1 flex-1">
                                    <Skeleton className="h-4 w-24" />
                                    <Skeleton className="h-4 w-32" />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="space-y-3">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="flex items-center space-x-3">
                                <Skeleton className="h-8 w-8 rounded-lg" />
                                <div className="space-y-1 flex-1">
                                    <Skeleton className="h-4 w-20" />
                                    <Skeleton className="h-4 w-40" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Token Section */}
                <div className="border-t pt-4">
                    <div className="flex items-center justify-between mb-3">
                        <Skeleton className="h-4 w-32" />
                        <Skeleton className="h-6 w-16" />
                    </div>
                    <Skeleton className="h-10 w-full rounded" />
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between pt-4 border-t mt-4">
                    <Skeleton className="h-4 w-40" />
                    <Skeleton className="h-4 w-24" />
                </div>
            </Card>

            {/* WhatsApp Card Skeleton */}
            <div className="mt-4">
                <Card className="p-3">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <Skeleton className="h-10 w-10 rounded-lg" />
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Skeleton className="h-4 w-32" />
                                    <Skeleton className="h-5 w-20 rounded-full" />
                                </div>
                                <Skeleton className="h-3 w-40" />
                                <Skeleton className="h-3 w-44" />
                            </div>
                        </div>
                        <Skeleton className="h-8 w-24" />
                    </div>
                </Card>
            </div>

            {/* Facebook Card Skeleton */}
            <div className="mt-4">
                <Card className="p-3 opacity-75">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <Skeleton className="h-10 w-10 rounded-lg" />
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Skeleton className="h-4 w-36" />
                                    <Skeleton className="h-5 w-24 rounded-full" />
                                </div>
                                <Skeleton className="h-3 w-32" />
                                <Skeleton className="h-3 w-36" />
                                <Skeleton className="h-3 w-52" />
                            </div>
                        </div>
                        <Skeleton className="h-8 w-28 opacity-50" />
                    </div>
                </Card>
            </div>
        </motion.div>
    );
}; 